import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Approach from "@/components/site/Approach";
import Services from "@/components/site/Services";
import Locations from "@/components/site/Locations";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-[#FAFAF9] text-stone-900" data-testid="home-page">
      <Navigation />
      <Hero />
      <About />
      <Approach />
      <Services />
      <Locations />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
